import ReportingForm from './ReportingForm/ReportingForm';

export const ReportingFormPage = ReportingForm;